<form (ngSubmit)="submitForm()" class="eb-place-order" [formGroup]="checkoutSubmitForm">
  <div class="eb-place-order__input-wrapper">
    <label *ngFor="let linkComponent of links$ | async">
      <input
        [attr.id]="linkComponent.uid"
        [formControl]="convertToFormControl(checkoutSubmitForm.get(linkComponent.uid))"
        type="checkbox"
        [attr.error]="
          (checkoutSubmitForm.controls[linkComponent.uid].invalid &&
            checkoutSubmitForm.controls[linkComponent.uid].touched) ||
          undefined
        "
      />
      <span class="form-check-label">
        {{ 'checkoutReview.' + linkComponent.uid + 'Pre' | cxTranslate }}
        <cx-generic-link
          [url]="linkComponent.url"
          [target]="linkComponent.target"
          [style]="linkComponent.styleAttributes"
          [class]="linkComponent.styleClasses"
        >
          {{ linkComponent.linkName }}
        </cx-generic-link>
        {{ 'checkoutReview.' + linkComponent.uid + 'Post' | cxTranslate }}
      </span>
    </label>
    <label class="eb-place-order__select-label">
      <span class="form-check-label eb-place-order__expoco-description">
        {{ 'checkoutReview.expocoTitle' | cxTranslate }}
      </span>
      <span class="form-check-label">
        {{ 'checkoutReview.selectTargetCountry' | cxTranslate }}
      </span>
      <eb-datalist
        [attr.id]="'expocoTargetCountrySelection'"
        [formControl]="convertToFormControl(checkoutSubmitForm.get('expocoTargetCountrySelection'))"
        positionDropdownLeft="true"
        [error]="
          (!checkoutSubmitForm.get('expocoTargetCountrySelection').valid &&
            checkoutSubmitForm.get('expocoTargetCountrySelection').touched) ||
          undefined
        "
        class="eb-place-order__select-field"
      >
        <option
          [value]="(activeCartService.getActive() | async).deliveryAddress.country.isocode"
          class="eb-place-order__expoco-default-country"
        >
          {{ (activeCartService.getActive() | async).deliveryAddress.country.name }}
        </option>
        <option
          *ngFor="let option of sortCountriesByName(countries$ | async)"
          [value]="option.isocode"
        >
          {{ option.name }}
        </option>
      </eb-datalist>
    </label>
    <label *ngIf="expocoBusinessPartnerSelectionRequired" class="eb-place-order__select-label">
      <span class="form-check-label">
        {{ 'checkoutReview.selectEndCustomer' | cxTranslate }}
      </span>
      <eb-datalist
        [attr.id]="'expocoBusinessPartnerSelection'"
        positionDropdownLeft="true"
        [formControl]="
          convertToFormControl(checkoutSubmitForm.get('expocoBusinessPartnerSelection'))
        "
        [error]="
          (!checkoutSubmitForm.get('expocoBusinessPartnerSelection').valid &&
            checkoutSubmitForm.get('expocoBusinessPartnerSelection').touched) ||
          undefined
        "
        class="eb-place-order__select-field"
      >
        <option *ngFor="let option of typesOfEndCustomer$ | async" [value]="option.partnerId">
          {{ option.name }}
        </option>
      </eb-datalist>
    </label>
  </div>
  <div class="eb-place-order__button-wrapper">
    <button
      type="submit"
      class="eb-place-order__button"
      data-cy="place-order-button"
      [disabled]="
        loading ||
        requestPending ||
        (verifyAsAgentHasPlaceOrderPermissionConsents() | async) ||
        (verifyAsAgentHasPlaceOrderUserRole() | async) ||
        (isValidatingShippingDate$ | async) ||
        !(isPlaceOrderValid$ | async)
      "
    >
      {{ 'checkoutReview.placeOrder' | cxTranslate }}
      <eb-spinner
        *ngIf="loading || requestPending"
        [size]="2"
        class="eb-place-order__spinner"
      ></eb-spinner>
    </button>
  </div>
</form>
